import httpManager from "@/app/shared/utils/httpManager";

export async function updateLoggedBusiness(business) {
  const url = "/settings/customer/";
  const response = await httpManager.uploadPut(url, business);
  return response.data;
}
